<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="CONSULTA EMPLEADO" key="1">
        <informacion-empleado @contractSelected="contractSelected"/>
        <dotaciones v-if="idEmp" :empleadoseleccionado="idEmp"/>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        idEmp: null
      }
    },
    methods: {
      contractSelected (idEmp) {
        this.idEmp = idEmp
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Dotaciones/ConsultaEmpleado.vue